import React from 'react';
import Dots from '../../../atoms/Dots/Dots';
import credentialBg from '../../../../app/assets/images/aboutUsImages/credential.webp';
import { ReactComponent as CredentialSpark } from '../../../../app/assets/images/aboutUsImages/credential-spark.svg';

type CredentialsSectionProps = {
  credentialsSection?: {
    title?: string;
    cards?: Array<{
      title?: string;
      description?: string[];
      color?: string;
    }>;
  };
};

const CredentialsSection = ({ credentialsSection }: CredentialsSectionProps) => {
  if (!credentialsSection) return null;

  const { title, cards = [] } = credentialsSection;

  return (
    <section className="px-4 pt-8 pb-14 md:pt-10 md:pb-20">
      <div className="max-w-[2400px] mx-auto px-4 md:px-8 lg:px-16 xl:px-24 2xl:px-32 3xl:px-48">
        <div className="text-center">
          <div className="text-[34px] sm:text-[40px] md:text-[44px] xl:text-[52px] 2xl:text-[64px] 3xl:text-[80px] leading-[1.1] font-semibold text-white">
            {title}
          </div>
          <Dots width="w-4.5 md:w-5" height="h-4.5 md:h-5" className="mt-4 justify-center gap-4" />
        </div>

        <div className="mt-8">
          <div
            className="h-[220px] sm:h-[280px] md:h-[330px] xl:h-[400px] 2xl:h-[500px] 3xl:h-[620px] bg-center bg-cover bg-no-repeat grayscale"
            style={{ backgroundImage: `linear-gradient(rgba(10, 10, 10, 0.22), rgba(10, 10, 10, 0.22)), url(${credentialBg})` }}
          />

          <div className="relative z-10 -mt-20 sm:-mt-24 md:-mt-28 xl:-mt-32 2xl:-mt-40 3xl:-mt-52 px-2 sm:px-8 md:px-10">
            <div className="grid max-w-[660px] md:max-w-[720px] xl:max-w-none mx-auto grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 xl:gap-6 2xl:gap-8 3xl:gap-12">
              {cards.map((card, index) => (
                <div
                  key={`${card.title || 'detail'}-${index}`}
                  className="min-h-[118px] md:min-h-[136px] xl:min-h-[160px] 2xl:min-h-[190px] 3xl:min-h-[240px] bg-[#1F1F1F] px-4 py-4 md:px-5 md:py-5 xl:px-7 xl:py-6 2xl:px-9 2xl:py-8 3xl:px-12 3xl:py-10 shadow-[0_12px_30px_rgba(0,0,0,0.35)]"
                >
                  <CredentialSpark
                    aria-hidden="true"
                    className="w-[20px] h-[20px] md:w-[22px] md:h-[22px] xl:w-[26px] xl:h-[26px] 2xl:w-[30px] 2xl:h-[30px] 3xl:w-[38px] 3xl:h-[38px]"
                    style={{ color: card.color }}
                  />
                  {card.title ? (
                    <div className="mt-2 text-[26px] md:text-[30px] xl:text-[36px] 2xl:text-[44px] 3xl:text-[56px] leading-none font-semibold" style={{ color: card.color }}>
                      {card.title}
                    </div>
                  ) : null}
                  <div className={`${card.title ? 'mt-2' : 'mt-3'} text-[11px] md:text-[13px] xl:text-[15px] 2xl:text-[17px] 3xl:text-[21px] leading-[1.22] xl:leading-[1.4] font-medium text-white/80`}>
                    {(card.description ?? []).map((line) => (
                      <div key={line}>{line}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredentialsSection;
